// Angular
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Component, inject } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

// Antd
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzTypographyComponent } from "ng-zorro-antd/typography";
import { NzColDirective, NzRowDirective } from "ng-zorro-antd/grid";
import { NzDropdownModule } from "ng-zorro-antd/dropdown";

// Services
import { UserService } from "#services/user/user.service";
import { AuthService } from "#services/auth/auth.service";
import { LoaderService } from "#services/loader/loader.service";
import { NavigationService } from "#services/navigation/navigation.service";
import { CookieBridgeService } from "#services/cookie-bridge/cookie-bridge.service";

// Components
import { LoaderComponent } from "#components/loader/loader.component";
import { NavigationComponent } from "#components/navigation/navigation.component";

// Models
import { UserOrNull } from "#models/user";

@Component({
    selector: "app-template-logged-in",
    imports: [
        RouterLink,
        FormsModule,
        RouterOutlet,
        NzIconModule,
        NzMenuModule,
        NzLayoutModule,
        NzButtonModule,
        NzRowDirective,
        NzColDirective,
        NzSelectModule,
        LoaderComponent,
        NavigationComponent,
        NzTypographyComponent,
        NzDropdownModule,
    ],
    providers: [DatePipe],
    styleUrl: "./template-logged-in.component.scss",
    templateUrl: "./template-logged-in.component.html",
})
export class TemplateLoggedInComponent {
    user!: UserOrNull;
    isCollapsed!: boolean;

    public loaderService = inject(LoaderService);
    protected router = inject(Router);
    private userService = inject(UserService);
    private authService = inject(AuthService);
    private cookieService = inject(CookieBridgeService);
    private navigationService = inject(NavigationService);

    constructor() {
        this.userService.user$.pipe(takeUntilDestroyed()).subscribe((user) => (this.user = user));

        this.navigationService.init();

        this.isCollapsed = JSON.parse(
            this.cookieService.get("app.navigation.isCollapsed") || "false"
        );
    }

    collapsedChanged() {
        this.isCollapsed = !this.isCollapsed;
        this.cookieService.set("app.navigation.isCollapsed", JSON.stringify(this.isCollapsed));
    }

    logout() {
        this.authService.logout();
    }
}
